<template>
  <div class="wrapper-page">
    <bulk-delete-products-modal ref='bulkDeleteProductsModal' @success='fetchProducts' />
    <delete-products-modal ref='deleteProductsModal' @success='fetchProducts' />

    <modal ref='productSidebarEdit'>
      <template #header>
        <h5 class="modal-title mt-0">{{$t('products.edit_info')}}
          <span>{{$t('products.note')}}</span>
        </h5>
      </template>

      <template #body>
        <form @submit.prevent="">
          <div class="modal-body">
            <div class="form-group">
              <label class="col-form-label">
                {{$t('products.change')}} <strong>{{userProductTitle}}</strong> {{$t('products.change_to')}}
              </label>

              <input type="text" name="default[products]" class="form-control" required="required" v-model='userProduct.title' :placeholder="userProductTitle" />
            </div>
            <div class="form-group">
              <label class="col-form-label">
                {{$t('products.change')}} <strong>{{userProductName}}</strong> {{$t('products.change_to')}}
              </label>

              <input type="text" name="default[code]" class="form-control" v-model='userProduct.name' :placeholder="userProductName" />
            </div>
            <div class="form-group">
              <label class="col-form-label">
                {{$t('products.change')}} <strong>{{userProductCode}}</strong> {{$t('products.change_to')}}
              </label>

              <input type="text" name="default[name]" class="form-control" v-model='userProduct.code' :placeholder="userProductCode" />
            </div>
          </div>

          <div class="modal-footer">
            <button
                    type="reset"
                    data-dismiss="modal"
                    @click.prevent="resetValues"
                    class="btn btn-neutral">{{ $t('products.cancel') }}</button>
            <button
                    type="submit"
                    name="commit"
                    class="btn btn-primary"
                    @click.prevent="updateUserOptions">{{$t('products.save')}}</button>
          </div>
        </form>
      </template>
    </modal>
    <modal ref='productForm'>
      <template #header>
        <h5 v-if="!selectedProduct.hasOwnProperty('id')" class="modal-title mt-0">{{$t('products.add')}} {{userProductTitle}}</h5>
        <h5 v-else class="modal-title mt-0">{{$t('products.edit_entity')}} {{userProductTitle}}</h5>
      </template>

      <template #body>
        <form @submit.prevent="createOrUpdateProduct($event)">
          <div class="modal-body">
            <div class="form-group">
              <label class="col-form-label">
                {{userProductName}}
              </label>

              <input type="text" name="product[name]" class="form-control" required="required" v-model='selectedProduct.name' />
            </div>

            <div class="form-group">
              <label class="col-form-label">
                {{userProductCode}}
              </label>

              <input type="text" name="product[code]" class="form-control" v-model='selectedProduct.code' />
            </div>
          </div>

          <div class="modal-footer">
            <input
                    v-if="!selectedProduct.hasOwnProperty('id')"
                    type='submit'
                    name='commit'
                    :value="$t('contacts.edit_modal.save_add_more')"
                    class='btn btn-outline-primary'
                    @click.prevent="saveAndAdd">
            <input type="submit" name="commit" :value="$t('products.save')" class="btn btn-primary">
          </div>
        </form>
      </template>
    </modal>

    <import ref='import' />

    <div class="container-fluid">
      <h1 class="page-title">{{userProductTitle}}
        <a href="#" class="edit" @click.prevent='openModal($refs.productSidebarEdit)'>
          {{ $t('products.edit_entity') }}
        </a>
      </h1>
      <div class='clearfix'></div>


      <a href="#" @click.prevent="openModal($refs.productForm)" class="btn btn-primary float-right">
        {{$t('products.add_new')}}
      </a>

      <a href="#" @click.prevent="$refs.import.open" class="btn btn-outline-primary float-right m-r-10">
        {{$t('products.tabs.import_product')}}
      </a>

      <div class="nav-tabs-wrapper">
        <ul role="tablist" class="nav nav-tabs">
          <li class="nav-item">
            <router-link :to="{ name: 'products' }" :class="['nav-link', 'show', { active: activeTab == 'active' }]">
              {{ userProductTitle }} ({{this.activeProductsCount}})
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'archived_products' }" :class="['nav-link', 'show', { active: activeTab == 'archived' }]">
              {{$t('products.archived')}} {{ userProductTitle}} ({{this.archivedProductsCount}})
            </router-link>
          </li>
        </ul>
      </div>
      <div class="tab-content" id="nav-tabContent">
        <bulk-tag-products-modal ref='bulkTagProductsModal' @success='fetchProducts()' />

        <div v-for="[id, active] in tabs" :id='id' role="tabpanel" :class="['tab-pane', {active: active}]" :key='id'>
          <div class='bulk-container' v-show='selectedProducts.length > 0'>
            <span>{{ selectedProducts.length }} products selected</span>
            <ul>
              <li>
                <a @click.prevent="$refs.bulkTagProductsModal.open(selectedProducts)" href="#" class="dropdown-item">
                  <i class="fas fa-tag"></i>
                  {{ $t('folder_show.add_tags') }}
                </a>
              </li>
              <li>
                <a @click.prevent="$refs.bulkDeleteProductsModal.open(selectedProducts)" href="#" class="dropdown-item">
                  <i class="far fa-trash-alt"></i>
                  {{ $t('record_show.bulk_delete') }}
                </a>
              </li>
            </ul>
          </div>
          <div class="table_wrapper" v-if="products.length > 0 && !loading">
            <table class="table">
              <thead>
              <tr>
                <th>
                  <input type='checkbox' @click='toggleAllProducts' :checked='isSuperset(new Set(selectedProducts), new Set(prodIds))'>
                </th>
                <th>
                  <router-link :to="{ query: { 'sort[col]': 'name', 'sort[dir]': sortDirection('name') } }">
                    {{userProductName}}
                    <span :class="classSortDirection('name')"></span>
                  </router-link>
                </th>
                <th>
                  <router-link :to="{ query: { 'sort[col]': 'code', 'sort[dir]': sortDirection('code') } }">
                    {{userProductCode}}
                    <span :class="classSortDirection('code')"></span>
                  </router-link>
                </th>
                <th>{{$t('products.list.tags')}}</th>
                <th>{{$t('products.list.actions')}}</th>
              </tr>
              </thead>

              <tbody name="fade" is="transition-group">
              <tr v-for='product in products' :key='product.id'>
                <td>
                  <input type='checkbox' v-model='selectedProducts' :value='product.id' />
                </td>

                <td>
                  <router-link :to="{name: 'product', params: {id: product.id}}">
                    {{product.name}}
                  </router-link>
                </td>

                <td>
                  <router-link :to="{name: 'product', params: {id: product.id}}" v-if="product.code">
                    {{product.code}}
                  </router-link>
                  <span v-else>{{$t('products.list.no_code')}}</span>
                </td>

                <td class="tag-dropdown-column">
                  <tag-manager resourceType='product' :resource="product" v-on:reload-list="fetchProducts()" />

                  <div class="existing-tags-wrapper" :class="tag.color" v-for="tag in product.tags" :key='tag.id'>
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                      <label class="btn active">
                        <router-link :to="{name: 'tag', params: { id: tag.id }}">
                          {{tag.name}}
                        </router-link>
                      </label>

                      <label class="btn" @click.prevent="removeConnectedTag(tag, product.id)">
                        <i class="fa fa-remove"></i>
                      </label>
                    </div>
                  </div>
                </td>

                <td class="dropdown-column">
                  <div class="dropdown">
                    <button aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" type="button"
                            class="btn dropdown-toggle">
                      · · ·
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <ul>
                        <li>
                          <a href="#" @click.prevent="openModal($refs.productForm, product)" class="dropdown-item">
                            <i class="far fa-edit"></i>
                            {{ $t('folders_list.edit') }}
                          </a>
                        </li>
                        <li>
                          <a @click.prevent='toggleArchiveProduct(product)' href="#" class='dropdown-item'>
                            <i class="fas fa-archive"></i>
                            {{ product.archive ? $t('products.archive.unarchive_product_button') : $t('products.archive.archive_product_button') }}
                          </a>
                        </li>
                        <li>
                          <a @click.prevent='$refs.deleteProductsModal.open(product)' href="#" class='dropdown-item'>
                            <i class="fas fa-trash"></i>
                            {{ $t('shared.delete') }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="empty-list-wrapper" v-if="!products.length > 0 && !loading">
            <img src='../assets/empty_states/products.png' width="230">
            <p>{{ $t('products.list.no_products') }}</p>
          </div>
          <loading v-if="loading" />
          <pagination :meta='meta' />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _modal from '../components/_modal'
  import _import from '../components/products/_import'
  import _pagination from '../components/_pagination'
  import _loading from '../components/_loading'

  import _tag_manager from '../components/tags/_tags_manager'
  import _delete_products_modal from '../components/products/_delete_products_modal'

  import _bulk_tag_products_modal from '../components/products/_bulk_tag_products_modal'
  import _bulk_delete_products_modal from '../components/products/_bulk_delete_products_modal'

  export default {
    name: 'products',
    components: {
      pagination: _pagination,
      modal: _modal,
      import: _import,
      loading: _loading,

      'tag-manager': _tag_manager,
      'delete-products-modal': _delete_products_modal,

      'bulk-tag-products-modal': _bulk_tag_products_modal,
      'bulk-delete-products-modal': _bulk_delete_products_modal,
    },
    props: {
      activeTab: {
        type: String,
        default: 'active'
      }
    },
    created() {
      this.fetchProducts()
      this.store.sendMetrics({name: 'products', params: this.$route.params, path: this.$route.fullPath})
    },
    data() {
      return {
        selectedProduct: {},
        userProduct: {},
        activeProductsCount: null,
        archivedProductsCount: null,
        selectedProducts: [],
        loading: false,
      }
    },
    watch: {
      query() {
        this.fetchProducts()
      },
    },
    computed: {
      params() {
        return Object.assign({ 'filters[archive]': this.$props.activeTab == 'archived' }, this.query)
      },
      products() {
        return this.state.products || []
      },
      prodIds() {
        return this.products.map(p => p.id)
      },
      tabs() {
        return [
          ['products', this.activeTab == 'active'],
          ['archived', this.activeTab == 'archived']
        ]
      },
    },
    methods: {
      sortDirection(col) {
        if (col !== this.query['sort[col]']) {
          return 'asc'
        }
        return this.query['sort[dir]'] === 'asc' ? 'desc' : 'asc'
      },
      classSortDirection(col) {
        if (col !== this.query['sort[col]'])
          return ['fa', 'fa-sort']
        return this.query['sort[dir]'] === 'asc' ? ['fa', 'fa-sort-up'] : ['fa', 'fa-sort-down']
      },
      fetchProducts() {
        this.selectedProducts = []
        this.loading = true

        this.listStore.getProducts({ 'filters[archive_eq]': false }).then((data) => {
          this.activeProductsCount = data.meta.total
        })

        this.listStore.getProducts({ 'filters[archive_eq]': true }).then((data) => {
          this.archivedProductsCount = data.meta.total
        })

        this.store.getProducts(this.params).then(() => {
          this.loading = false
          this.userProduct = Object.assign({}, this.currentUser.defaults.product_view)
        })
      },
      openModal(modal, product) {
        this.selectedProduct = Object.assign({}, product)
        modal.open()
      },
      removeConnectedTag(tag, productId) {
        this.store.removeConnectedTag(tag.id, { product_id: productId }).then(() => {
          this.fetchProducts()
        })
      },
      createOrUpdateProduct(event) {
        let promise = null
        const params = new FormData(event.target)
        if (!params.get('product[code]')) {
          params.delete('product[code]')
        }
        if (this.selectedProduct.id) {
          promise = this.store.updateProduct(this.selectedProduct.id, this.selectedProduct)
          this.store.sendMetrics({name: 'update_product', params: this.$route.params, path: this.$route.fullPath})
        } else {
          promise = this.store.createProduct(params)
          this.store.sendMetrics({name: 'create_product', params: this.$route.params, path: this.$route.fullPath})
        }
        promise.then(() => {
          this.fetchProducts()
          this.$refs.productForm.close()
          this.$toastr.success(this.$t('flash_messages.product_created'))
        })
      },
      toggleArchiveProduct(product) {
        this.store.updateProduct(product.id, { archive: !product.archive }).then(() => {
          this.store.sendMetrics({name: 'toggle_archive_product', params: this.$route.params, path: this.$route.fullPath})
          this.fetchProducts()
          this.listStore.getProducts()
        })
      },
      isSuperset(set, subset) {
        for (let elem of subset)
          if (!set.has(elem))
            return false
        return true
      },
      toggleAllProducts(e) {
        if (e.target.checked)
          this.selectedProducts = this.selectedProducts.concat(this.prodIds)
        else
          this.selectedProducts = this.selectedProducts.filter(id => this.prodIds.indexOf(id) < 0)
      },
      saveAndAdd() {
        let p = {}
        p.product = {
          name: this.selectedProduct.name,
          code: this.selectedProduct.code,
        }
        this.store.createProduct(p).then(() => {
          this.store.sendMetrics({name: 'create_product', params: this.$route.params, path: this.$route.fullPath})
          this.fetchProducts()
          this.selectedProduct = {}
          this.$toastr.success(this.$t('flash_messages.product_created'))
        })
      },
      updateUserOptions() {
        let newDefaults = Object.assign({}, this.currentUser.defaults, { product_view: this.userProduct })
        this.store.updateUserProfile({ user: { defaults: newDefaults } }).then(() => {
          this.store.getCurrentUser()
          this.$refs.productSidebarEdit.close()
        })
      },
      resetValues() {
        this.userProduct = Object.assign({}, this.currentUser.defaults.product_view)
      },
    }
  }
</script>
<style lang="sass" scoped>
  .modal-header
    h5
      span
        display: block
        font-size: 14px
  .bulk-container
    ul
      margin-top: 0
      li
        a:hover
          text-decoration: none

</style>
